// extracted by mini-css-extract-plugin
export default {"main":"PreviewSlide_main__RUkPe","black":"PreviewSlide_black__qzr9U","imgContainer":"PreviewSlide_imgContainer__KpRxL"};